export interface SelectionsDataType {
  eventid: string;
  commonId: number;
  oddsDecimal: number;
  market: string;
}

export enum ActionType {
  UPDATE_BETSLIP = "UPDATE_BETSLIP",
  ADD_SELECTION_TO_BETSLIP = "ADD_SELECTION_TO_BETSLIP",
  REMOVE_SELECTION_FROM_BETSLIP = "REMOVE_SELECTION_FROM_BETSLIP",
  UPDATE_MATCH_SELECTION = "UPDATE_MATCH_SELECTION",
  CLEAR_BETSLIP = "CLEAR_BETSLIP",
  SET_TAB_STAKE = "SET_TAB_STAKE",
  SET_OTHER_STAKE = "SET_OTHER_STAKE",
  SET_STAKE = "SET_STAKE",
  RESET_STAKE = "RESET_STAKE",
}

export interface UpdateBetslipAction {
  type: ActionType.UPDATE_BETSLIP;
  payload: SelectionsDataType[];
}

export interface AddSelectionToBetslipAction {
  type: ActionType.ADD_SELECTION_TO_BETSLIP;
  payload: SelectionsDataType;
}

export interface RemoveSelectionFromBetslipAction {
  type: ActionType.REMOVE_SELECTION_FROM_BETSLIP;
  payload: SelectionsDataType;
}

export interface UpdateMatchSelectionAction {
  type: ActionType.UPDATE_MATCH_SELECTION;
  payload: SelectionsDataType;
}

export interface ClearBetslipAction {
  type: ActionType.CLEAR_BETSLIP;
  payload: SelectionsDataType;
}

export interface SetTabStakeAction {
  type: ActionType.SET_TAB_STAKE;
  payload: Object;
}

export interface SetOtherStakeAction {
  type: ActionType.SET_OTHER_STAKE;
  payload: Object;
}

export interface SetStakeAction {
  type: ActionType.SET_STAKE;
  payload: Object;
}

export interface ResetStakeAction {
  type: ActionType.RESET_STAKE;
  payload: Object;
}

export type Action =
  | UpdateBetslipAction
  | AddSelectionToBetslipAction
  | RemoveSelectionFromBetslipAction
  | UpdateMatchSelectionAction
  | ClearBetslipAction
  | SetTabStakeAction
  | SetOtherStakeAction
  | SetStakeAction
  | ResetStakeAction;

export interface ReducerState {
  selections: SelectionsDataType[];
  selectionsData: string;
  selectionsCopy: SelectionsDataType[];
  stake: string;
  tabsInUse: boolean;
}
